import { create } from 'zustand';
import { PaymentStatementScheduleInfo } from '@models/paymentStatement';
import { ProductOrderViewModel } from '@models/productOrderView';

export interface ProductOrderScheduleContext {
  scheduleId?: string;
  optionName?: string;
  scheduleName?: string;
  scheduleInfo?: PaymentStatementScheduleInfo;
  notes?: string;
  sourceName?: string;
}

interface State {
  data?: ProductOrderViewModel;
  scheduleContext?: ProductOrderScheduleContext;
  show: boolean;
}
interface Actions {
  open: (data: ProductOrderViewModel, scheduleContext?: ProductOrderScheduleContext) => void;
  close: () => void;
}

const useProductOrderDetailModalStore = create<State & Actions>((set) => ({
  show: false,
  data: undefined,
  scheduleContext: undefined,
  close: () => set({ show: false, data: undefined, scheduleContext: undefined }),
  open: (data, scheduleContext) => set({ data, scheduleContext, show: true }),
}));

export default useProductOrderDetailModalStore;
